interface ShiftKeysToPublish {
  draftKeys: string[];
  pendingForApprovalKeys: string[];
}

export function getShiftKeysToPublish(
  allDraftKeys: string[],
  allPendingForApprovalKeys: string[],
  selectedShiftKeys: string[],
): ShiftKeysToPublish {
  if (!selectedShiftKeys.length) {
    return {
      draftKeys: allDraftKeys,
      pendingForApprovalKeys: allPendingForApprovalKeys,
    };
  }

  return {
    draftKeys: selectedShiftKeys.filter(key => allDraftKeys.includes(key)),
    pendingForApprovalKeys: selectedShiftKeys.filter(key => allPendingForApprovalKeys.includes(key)),
  };
}
